export default __webpack_public_path__ + "static/9918production-eb445128f2f4bcddede924ad85192bae.jpg";